import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async list({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.list'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getComplexList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.complex_list'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getTreeList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.tree_list'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async filterList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.get_filter_list'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async detail({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.detail', payload))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async update({ commit }, payload) {
    return await apiService.post(route('member.fcs.forest.update'), payload)
  },
  async delete({ commit }, payload) {
    return await apiService.post(route('member.fcs.forest.delete', payload))
  },
  async deleteAll({ commit }, payload) {
    return await apiService.post(route('member.fcs.forest.delete_all', payload))
  },
  async importForestManagementPlan({ commit }, payload) {
    return await apiService.post(route('member.fcs.forest.import'), payload)
  },
  async importOperationInformation({ commit }, payload) {
    return await apiService.post(route('member.fcs.forest.import_operation'), payload)
  },
  async downloadCsv({}, payload) {
    const response = await apiService.downloadCsv(route('member.fcs.forest.download'), payload)
    if (response.status && response.status === 200) {
      return response
    } else if (response.data) {
      return { errors: response.data }
    } else {
      return { errors: 'Unknown' }
    }
  },
  async yieldTableList({ commit }) {
    const apiResult = await apiService.get(route('member.fcs.forest.yield_table_list'))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async treeSpeciesList({ commit }) {
    const apiResult = await apiService.get(route('member.fcs.forest.tree_species_list'))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async operationList({ commit }) {
    const apiResult = await apiService.get(route('member.fcs.forest.operation_list'))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async ownerList({ commit }) {
    const apiResult = await apiService.get(route('member.fcs.forest.owner_list'))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async coordFromAddress({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.forest.coord_from_address'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
